module.exports = __webpack_public_path__ + "img/jk_tab_active.38467ad8.png";